import Store from '@/services/store'
import Router from '@/services/router'
import checkInLionheartModule from '../../checkin-lionheart/module'
import checkInSiteModule from '../../checkin-site/module'
import checkInFacilityModule from '../../checkin-facility/module'
import checkInSuperAdminModule from '../../checkin-super-admin/module'

export default {
	namespaced: true,
	
	state: {},
	
	getters: {},
	
	mutations: {},
	
	actions: {
		initialize ({ dispatch }) {
			console.info('System initializing...')
			console.info('System initialized.')
			dispatch('initializeModule', checkInLionheartModule)
			dispatch('initializeModule', checkInSiteModule)
			dispatch('initializeModule', checkInFacilityModule)
			dispatch('initializeModule', checkInSuperAdminModule)
		},
		initializeModule ({ dispatch }, module) {
			Store.registerModule(module.name, module.store)
			Router.addRoutes(module.routes)
			dispatch(module.name + '/initialize', null, { root: true })
		}
	}
}
